import { render, staticRenderFns } from "./EmpadronarExtranjero.vue?vue&type=template&id=32fe27f0&scoped=true&"
import script from "./EmpadronarExtranjero.vue?vue&type=script&lang=js&"
export * from "./EmpadronarExtranjero.vue?vue&type=script&lang=js&"
import style0 from "./EmpadronarExtranjero.vue?vue&type=style&index=0&id=32fe27f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fe27f0",
  null
  
)

export default component.exports